import { render, staticRenderFns } from "./OrderHotelQuotation.vue?vue&type=template&id=2fc98c82&scoped=true"
import script from "./OrderHotelQuotation.vue?vue&type=script&lang=js"
export * from "./OrderHotelQuotation.vue?vue&type=script&lang=js"
import style0 from "./OrderHotelQuotation.vue?vue&type=style&index=0&id=2fc98c82&prod&lang=scss&scoped=true"
import style1 from "./OrderHotelQuotation.vue?vue&type=style&index=1&id=2fc98c82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc98c82",
  null
  
)

export default component.exports